import React, {useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import capaPetFriends from "../assets/images/capa-petfriends.png"
import SocWebSite from "../assets/images/soc-website.png";
import PortfolioWebSite from "../assets/images/portfolio-website.png";
import ReactApiReduxDashboard from "../assets/images/react-api-redux-dashboard.png";
import ConvidadosContatos from "../assets/images/convidados-contatos.png";
import RegistradoresWebSite from "../assets/images/ri-digital-1.png";
import OficioWebSite from "../assets/images/oficio-website.png";
import ArArispWebSite from "../assets/images/Ar-Arisp.png";
import FICWebSite from "../assets/images/fic-website.png";
import VolligWesite from "../assets/images/vollig.jpg";
import MandalaWebSite from "../assets/images/mandala.jpg";
import CenprotWebSite from "../assets/images/cenprot-web-site.png";


const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
    width: "100%",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: "20px 0",
    "& > * + *": {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  },
  media: {
    height: 140,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  descriptionModal: {
    color: "#111111",
    textAlign: "left",
    fontWeight: "bold"
  },
  titleProject: {
    fontSize: "20px",
    color: "#26a69a"
  },
  titlePortifolio:{
    fontSize:"30px",
    color: "#26a69a",
    margin:"15px 0"
  },
  "@media (max-width: 600px)": {
    titlePortifolio: {
      fontSize:'18px',
      textAlign:'center',
      marginBottom:'20px',
      marginTop:'0',
      display:'inline-block'
    }
}
}));

const Portfolio = () => {
  const [open, setOpen] = useState(false); /* open Modal */
  const [titleProject, settitleProject] = useState("");
  const [detailsProject, setdetailsProject] = useState("");
  const [websiteImgDetails, setwebsiteImgDetails] = useState("");
  const [linkProject, setlinkProject] = useState("");
  const [loading, setLoading] = useState(false);
useEffect(() => {
  const scrollToSection = () => {
    const hash = window.location.hash;

    // Exemplo: "#/portfolio#react"
    const parts = hash.split("#");
    const sectionId = parts.length > 2 ? parts[2] : null;

    if (!sectionId) return;

    setTimeout(() => {
      const section = document.getElementById(sectionId);

      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 500);
  };

  scrollToSection();

  window.addEventListener("hashchange", scrollToSection);

  return () => {
    window.removeEventListener("hashchange", scrollToSection);
  };
}, []);


const { categoria } = useParams();
useEffect(() => {
  if (!categoria) return;

  setTimeout(() => {
    const section = document.getElementById(categoria);

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, 500);
}, [categoria]);

  const portfoliosReact = [
    {
      title: "React API Redux",
      description: `
    <p class="project-highlight">
      Dashboard administrativo desenvolvido em React JS a partir de uma base Material UI, evoluido para consumir uma API propria em PHP/MySQL e gerenciar tarefas com Redux, Redux Thunk e Axios.
    </p>

    <p>
      O projeto implementa um fluxo completo de tarefas, com listagem, cadastro, remocao e atualizacao de status. A aplicacao utiliza estado global com Redux e chamadas assincronas para uma API REST em PHP, mantendo os dados persistidos em MySQL e separados por usuario atraves do header <strong>x-tenant-id</strong>.
    </p>

    <h3>Minhas contribuicoes</h3>
    <ul>
      <li>
        <strong>Integracao React com Redux:</strong> implementei reducers, actions e fluxos assincronos com Redux Thunk para listar, adicionar, remover e concluir tarefas.
      </li>

      <li>
        <strong>Consumo de API com Axios:</strong> centralizei as requisicoes HTTP usando uma URL configurada por variavel de ambiente e enviei o identificador do usuario logado nas operacoes.
      </li>

      <li>
        <strong>Backend PHP com MySQL:</strong> desenvolvi uma API REST com PDO para atender metodos GET, POST, PATCH e DELETE, incluindo validacoes, CORS e respostas JSON.
      </li>

      <li>
        <strong>Interface administrativa:</strong> adaptei o template Material UI para incluir uma area de tarefas com formulario, tabela, categorias, acoes por linha e dialogos de feedback.
      </li>

      <li>
        <strong>Controle por usuario:</strong> organizei a persistencia por tenant, permitindo que cada usuario visualize e manipule apenas suas proprias tarefas.
      </li>
    </ul>

    <h3>Tecnologias utilizadas</h3>
    <p>
      <strong>React JS, Redux, Redux Thunk, React Redux, Axios, Material UI, React Router, PHP, PDO, MySQL, REST API e CORS.</strong>
    </p>
  `,
      imageUrl: ReactApiReduxDashboard,
      websiteImgDetails: ReactApiReduxDashboard,
      link: "https://rafaeldemelo.com.br/react-api-redux/",
    },
    {
      title: "Convidados",
      description: `
    <p class="project-highlight">
      Aplicacao de cadastro de contatos desenvolvida em React com TypeScript, Material UI, Formik e Yup, criada para praticar componentizacao, validacao de formularios e gerenciamento de estado com hooks.
    </p>

    <p>
      O projeto permite cadastrar, listar e excluir contatos, exibindo nome, idade, e-mail e telefone em uma interface responsiva. O formulario possui validacao por schema, campos com icones, mensagens de erro e reset automatico apos o envio.
    </p>

    <h3>Minhas contribuicoes</h3>
    <ul>
      <li>
        <strong>Arquitetura em componentes:</strong> separei o fluxo em componentes de formulario, lista, modelo de contato e hook de logica para manter o codigo organizado e reutilizavel.
      </li>

      <li>
        <strong>Formulario com Formik e Yup:</strong> implementei validacoes para nome, idade, e-mail e telefone, garantindo feedback visual e consistencia dos dados cadastrados.
      </li>

      <li>
        <strong>Estado com React Hooks:</strong> criei um hook customizado para adicionar contatos, gerar IDs com UUID e remover registros da lista.
      </li>

      <li>
        <strong>Interface com Material UI:</strong> construi uma tela responsiva com Container, Stack, Paper, Chip, Table, TextField e IconButton, incluindo estado vazio para a lista.
      </li>
    </ul>

    <h3>Tecnologias utilizadas</h3>
    <p>
      <strong>React, TypeScript, Material UI, Formik, Yup, UUID, React Hooks, HTML5 e CSS3.</strong>
    </p>
  `,
      imageUrl: ConvidadosContatos,
      websiteImgDetails: ConvidadosContatos,
      link: "https://rafaeldemelo.com.br/convidados/",
    },
    {
      title: "FIC ONR",
      description: `
    <p class="project-highlight"><strong>FIC/SREI</strong> é a plataforma de autenticação de usuários para o **Fundo para Implementação e Custeio do Serviço de Registro Eletrônico de Imóveis**, desenvolvido para simplificar o acesso e garantir a segurança nas transações realizadas pelos cartórios de imóveis e seus usuários.</p>

    <h3>Minhas Contribuições:</h3>
    <ul>
      <li><strong>Desenvolvimento da Plataforma de Autenticação de Usuários com Certificado Digital</strong>: Fui responsável pela implementação da autenticação de usuários através de <strong>certificado digital</strong>, garantindo que apenas usuários autorizados tivessem acesso aos serviços sensíveis da plataforma, como a consulta e envio de informações fiscais.</li>
      <li><strong>Desenvolvimento do Frontend com React JS</strong>: Atuei no desenvolvimento da interface do usuário utilizando <strong>React JS</strong>, garantindo que a plataforma fosse interativa, eficiente e responsiva, proporcionando uma experiência fluida para os usuários finais.</li>
      <li><strong>Utilização de TypeScript e TailWind CSS</strong>: Utilizei <strong>TypeScript</strong> para garantir maior segurança no código, prevenindo erros de execução, e <strong>TailWind CSS</strong> para criar uma interface visualmente agradável e responsiva, adaptada a diferentes dispositivos.</li>
      <li><strong>Otimização da Performance da Plataforma</strong>: Trabalhei na otimização da performance da plataforma, assegurando que a aplicação fosse capaz de lidar com um grande número de acessos simultâneos sem comprometer a experiência do usuário.</li>
    </ul>

    <h3>Tecnologias Utilizadas:</h3>
    <ul>
      <li><strong>React JS</strong> para o desenvolvimento do frontend, proporcionando uma interface dinâmica e altamente interativa.</li>
      <li><strong>TypeScript</strong> para garantir maior segurança no código, prevenindo erros e melhorando a escalabilidade do sistema.</li>
      <li><strong>TailWind CSS</strong> para o desenvolvimento de uma interface visual moderna e responsiva.</li>
      <li><strong>Certificado Digital</strong> para autenticação de usuários, garantindo segurança e confiabilidade nas transações realizadas na plataforma.</li>
    </ul>
  `,

      imageUrl: FICWebSite,
      websiteImgDetails: FICWebSite,
      link: "https://fic.srei.onr.org.br/auth/",
    },
	{
  title: "Portfolio",
  description: `
    <p class="project-highlight">
      Portfólio profissional desenvolvido em React JS para apresentação de projetos, habilidades técnicas e experiências, com navegação segmentada por stack e formulário de contato integrado com envio de e-mail via PHPMailer.
    </p>

    <p>
      Este portfólio foi desenvolvido com o objetivo de apresentar minha trajetória profissional de forma clara, moderna e organizada, destacando projetos em <strong>.NET</strong>, <strong>React JS</strong>, <strong>WordPress/PHP</strong> e outras tecnologias utilizadas ao longo da minha experiência.
    </p>

    <h3>Minhas contribuições</h3>
    <ul>
      <li>
        <strong>Desenvolvimento frontend com React JS:</strong> criei a interface do portfólio utilizando React, organizando os componentes de forma modular e mantendo uma navegação fluida entre as páginas.
      </li>

      <li>
        <strong>Estrutura dinâmica de conteúdo:</strong> organizei projetos e habilidades em estruturas de dados, permitindo que os blocos visuais sejam renderizados dinamicamente a partir de objetos JavaScript.
      </li>

      <li>
        <strong>Navegação por categorias:</strong> implementei filtros e rotas segmentadas para facilitar o acesso direto aos projetos por stack, como .NET, React JS e WordPress/PHP.
      </li>

      <li>
        <strong>Estilização com SASS e CSS3:</strong> desenvolvi uma identidade visual responsiva, com cards, botões, menus, espaçamentos e componentes reutilizáveis para manter consistência entre as páginas.
      </li>

      <li>
        <strong>Formulário de contato com PHPMailer:</strong> implementei a integração do formulário de contato com envio de mensagens por e-mail utilizando PHPMailer no backend.
      </li>

      <li>
        <strong>Integração com GitHub:</strong> publiquei o código-fonte do projeto no GitHub, permitindo acesso ao versionamento e à estrutura técnica utilizada no desenvolvimento.
      </li>
    </ul>

    <h3>Tecnologias utilizadas</h3>
    <p>
      <strong>React JS, JavaScript, SASS, CSS3, HTML5, React Router, Git, GitHub, PHP e PHPMailer.</strong>
    </p>
  `,
      imageUrl: PortfolioWebSite,
      websiteImgDetails: PortfolioWebSite,
      link: "https://github.com/raffademello/portfolio-react",
}

  ];

  const portifoliosWP = [
	{
  title: "Mátrika / Mandala Comidas",
  description: `
    <p class="project-highlight">
      Projeto WordPress com WooCommerce voltado à venda online de alimentos especiais, com atuação em manutenção, evolução de funcionalidades, ajustes visuais e melhorias na experiência de compra.
    </p>

    <p>
      A <strong>Mátrika</strong>, anteriormente conhecida como <strong>Mandala Comidas Especiais</strong>, é uma marca voltada à produção e venda de alimentos especiais para pessoas com restrições alimentares, incluindo celíacos, alérgicos e intolerantes alimentares.
    </p>

    <p>
      Atuei na manutenção e evolução do site, realizando ajustes em páginas, componentes visuais, estrutura de conteúdo e funcionalidades ligadas ao ambiente WordPress e WooCommerce.
    </p>

    <h3>Minhas contribuições</h3>
    <ul>
      <li>
        <strong>Manutenção em WordPress:</strong> realizei ajustes e melhorias em um projeto já existente, mantendo a estrutura do site estável, organizada e funcional.
      </li>

      <li>
        <strong>Customizações em WooCommerce:</strong> atuei em ajustes relacionados à exibição de produtos, estrutura de loja, experiência de compra e elementos visuais do catálogo.
      </li>

      <li>
        <strong>Uso de Advanced Custom Fields:</strong> trabalhei com campos personalizados para organização e exibição de conteúdos específicos dentro do painel administrativo e das páginas do site.
      </li>

      <li>
        <strong>Ajustes de frontend:</strong> implementei melhorias visuais utilizando HTML5, SASS, CSS3 e JavaScript, respeitando a identidade visual da marca e a responsividade da interface.
      </li>

      <li>
        <strong>Suporte e evolução do projeto:</strong> contribuí com correções, melhorias pontuais e manutenção contínua para manter o site adequado às necessidades comerciais da marca.
      </li>
    </ul>

    <h3>Tecnologias utilizadas</h3>
    <p>
      <strong>WordPress, WooCommerce, Advanced Custom Fields, PHP, MySQL, HTML5, SASS, CSS3, JavaScript.</strong>
    </p>
  `,
  imageUrl: MandalaWebSite,
  websiteImgDetails: MandalaWebSite,
  link: "https://matrikacomidas.com.br/",
},
{
  title: "Petfriends",
  description: `
    <p class="project-highlight">
      Projeto WordPress desenvolvido do zero para uma marca do segmento pet food, com foco em identidade visual, organização de produtos, performance e facilidade de gerenciamento de conteúdo.
    </p>

    <p>
      O <strong>Petfriends</strong> é um site institucional desenvolvido para apresentar a marca, seus produtos e linhas de alimentação pet, utilizando WordPress, Elementor e personalizações no tema Hello Theme para atender ao layout fornecido pelo Web Designer.
    </p>

    <h3>Minhas contribuições</h3>
    <ul>
      <li>
        <strong>Estruturação do projeto:</strong> realizei a instalação e configuração inicial do WordPress, organizei a estrutura de pastas, plugins e configurações necessárias para o desenvolvimento.
      </li>

      <li>
        <strong>Desenvolvimento customizado:</strong> personalizei o Hello Theme e construí a interface visual conforme o layout aprovado, mantendo flexibilidade para edição futura pelo Elementor.
      </li>

      <li>
        <strong>Custom Post Types:</strong> implementei tipos de conteúdo personalizados para gerenciar produtos de forma organizada, facilitando cadastro, categorização e manutenção pelo painel administrativo.
      </li>

      <li>
        <strong>Segurança em formulários:</strong> integrei o Google reCAPTCHA ao formulário de contato para reduzir envios automatizados e reforçar a segurança da aplicação.
      </li>

      <li>
        <strong>Configuração de e-mail transacional:</strong> configurei SMTP para garantir o envio correto de mensagens, notificações e comunicações originadas pelo site.
      </li>

      <li>
        <strong>Otimização de performance:</strong> apliquei melhorias como cache, minificação de scripts, compressão de imagens e ajustes de carregamento para melhorar a velocidade das páginas.
      </li>
    </ul>

    <h3>Tecnologias utilizadas</h3>
    <p>
      <strong>WordPress, Elementor, Hello Theme, PHP, MySQL, Custom Post Types, Google reCAPTCHA, SMTP, HTML5, CSS3, JavaScript, Performance Optimization.</strong>
    </p>
  `,
		imageUrl: capaPetFriends,
      websiteImgDetails: capaPetFriends,
      link: "https://petfriends.com.br/turma-da-monica-pets/",
},

	{
  title: "Völlig",
  description: `
    <p class="project-highlight">
      Site institucional desenvolvido em WordPress para uma linha de produtos da Grossl, com foco em identidade visual, apresentação comercial, responsividade e publicação em ambiente de hospedagem.
    </p>

    <p>
      A <strong>Völlig</strong> é uma linha exclusiva de produtos da <strong>Grossl</strong>, voltada a oferecer soluções completas para varejo, indústria e projetos autônomos de alto padrão. O site foi desenvolvido para apresentar a marca, seus diferenciais e seus produtos de forma clara, moderna e responsiva.
    </p>

    <h3>Minhas contribuições</h3>
    <ul>
      <li>
        <strong>Desenvolvimento do tema personalizado:</strong> criei a estrutura visual do site em WordPress utilizando Elementor, seguindo a identidade da marca e garantindo uma interface moderna, responsiva e funcional.
      </li>

      <li>
        <strong>Implementação do layout institucional:</strong> construí as páginas principais do projeto, organizando seções de apresentação, chamadas comerciais, conteúdo institucional e áreas de produtos.
      </li>

      <li>
        <strong>Customizações em WordPress:</strong> realizei ajustes no tema, componentes visuais e estrutura do site para atender às necessidades específicas do projeto.
      </li>

      <li>
        <strong>Otimização e publicação:</strong> apliquei ajustes de performance, responsividade e carregamento, além de realizar a publicação final do site no servidor de hospedagem.
      </li>

      <li>
        <strong>Suporte e manutenção:</strong> após o lançamento, continuei prestando suporte técnico, realizando melhorias e ajustes para manter o site estável, atualizado e eficiente.
      </li>
    </ul>

    <h3>Tecnologias utilizadas</h3>
    <p>
      <strong>WordPress, Elementor, PHP, HTML5, CSS3, JavaScript, responsividade, otimização de performance e publicação em hospedagem.</strong>
    </p>
  `,
     imageUrl: VolligWesite,
      websiteImgDetails: VolligWesite,
      link: "https://vollig.com.br/",
},
    {
      title: "SOC",
      description: `
    <p class="project-highlight"><strong>SOC</strong> é uma plataforma de alta performance, desenvolvida para gerenciar o eSocial e oferecer soluções inovadoras para empresas que desejam automatizar seus processos de conformidade com o governo. O sistema foi desenvolvido utilizando **WordPress** e **Elementor**, com foco em escalabilidade e segurança. Além disso, atuei em diversos aspectos do projeto, incluindo o desenvolvimento frontend e operações de **DevOps**, garantindo a infraestrutura e segurança do servidor.</p>
    
    <h3>Minhas Contribuições:</h3>
    <ul>
      <li><strong>Desenvolvimento do Frontend com Elementor e WordPress:</strong> Utilizei **WordPress** e **Elementor** para criar uma plataforma moderna e responsiva. A construção de um tema personalizado e o design intuitivo garantiram uma ótima experiência para os usuários, especialmente em dispositivos móveis.</li>
      <li><strong>DevOps e Segurança no Servidor:</strong> Atuei na configuração do ambiente de **DevOps**, configurando servidores e pipelines para automação de deploys. Além disso, implementei **medidas de segurança** no servidor, protegendo a plataforma contra acessos não autorizados e garantindo a integridade dos dados dos usuários e da empresa.</li>
      <li><strong>Otimização e Performance:</strong> Realizei ajustes no sistema para melhorar o tempo de resposta e otimizar o carregamento de páginas, implementando técnicas de cache, compressão de arquivos e uso eficiente de recursos de servidor.</li>
      <li><strong>Integração de Funcionalidades Específicas:</strong> Implementei sistemas de **consulta de dados e envio de informações para o eSocial**, que permitem às empresas integrar os dados do seu time com as plataformas governamentais de forma rápida e segura.</li>
    </ul>

    <h3>Tecnologias Utilizadas:</h3>
    <ul>
      <li><strong>WordPress</strong> para o desenvolvimento de uma plataforma escalável e fácil de gerenciar.</li>
      <li><strong>Elementor</strong> para criação de layouts personalizados, oferecendo uma interface moderna e interativa.</li>
      <li><strong>DevOps</strong> para a automação do processo de deploy e manutenção da infraestrutura.</li>
      <li><strong>Medidas de segurança no servidor</strong> para garantir a proteção e integridade dos dados dos usuários e da plataforma.</li>
    </ul>
  `,

      imageUrl: SocWebSite,
      websiteImgDetails: SocWebSite,
      link: "https://www.soc.com.br/",
    },
  ]

  const portifoliosNET = [
{
  title: "ONR RI Digital",
  description: `
    <p class="project-highlight"><b>Sistema nacional voltado aos serviços eletrônicos de Registro de Imóveis do Brasil, desenvolvido para facilitar o acesso de usuários, cartórios e instituições aos serviços digitais da plataforma ONR.</b></p>
	<p>Atuei na manutenção, evolução e melhoria de módulos críticos da plataforma, com foco em autenticação, assinatura digital, pedidos eletrônicos, envio de documentos e experiência do usuário.</p>
    
    <h3>Minhas Contribuições:</h3>
    <ul>
	  <li><b>Migração do layout antigo para o novo layout:</b> participei da atualização da interface, adequando telas e fluxos aos novos padrões visuais, com foco em usabilidade, responsividade e performance.</li>
      <li><b>Manutenção de módulos em ASP.NET WebForms:</b> atuei em funcionalidades essenciais da plataforma, incluindo pedidos de certidão, e-protocolo e fluxos eletrônicos para envio de documentos aos Cartórios de Registro de Imóveis.</li>
      <li><b>Autenticação com Conta GOV e Certificado Digital:</b> implementei e mantive fluxos de autenticação segura, garantindo a identificação dos usuários no acesso aos serviços digitais da plataforma.</li>
      <li><b>Assinatura digital de documentos:</b> implementei funcionalidades de assinatura com certificado digital e Conta GOV, permitindo a assinatura segura e juridicamente válida de documentos dentro da plataforma.</li>
      <li><b>Gestão de arquivos e envio por e-mail:</b> desenvolvi recursos para download de documentos assinados e envio automático por e-mail, reduzindo etapas manuais e melhorando a experiência do usuário.</li>
    </ul>
    
    <h3>Tecnologias Utilizadas:</h3>
    <ul>
      <li><b>ASP.NET WebForms, C#, SQL Server, JavaScript, HTML, CSS, Certificado Digital, Conta GOV.</b></li>
    </ul>
  `,
  imageUrl: RegistradoresWebSite,
  websiteImgDetails: RegistradoresWebSite,
  link: "https://ridigital.org.br/",
},
  {
  title: "Ofício Eletrônico",
  description: `
    <p class="project-highlight">O <b>Ofício Eletrônico</b> é uma plataforma desenvolvida pelo <b>ONR — Operador Nacional do Sistema de Registro Eletrônico de Imóveis</b>, voltada à comunicação eletrônica entre cartórios de imóveis, órgãos públicos e usuários autorizados.<br>
	A solução centraliza consultas, solicitações e envio de documentos, reduzindo processos manuais e tornando a comunicação entre os envolvidos mais ágil, segura e rastreável.</p>

    <h3>Minhas Contribuições:</h3>
    <ul>
      <li><b>Manutenção de módulos em ASP.NET MVC:</b> atuei na manutenção e evolução de funcionalidades críticas da plataforma, incluindo autenticação de usuários, pedidos de certidão, status de pagamento e acompanhamento de documentos.</li>
      <li><b>Autenticação com certificado digital:</b> participei da implementação e manutenção de fluxos de autenticação segura com certificado digital, garantindo controle de acesso e integridade no uso da plataforma.</li>
      <li><b>Filtros de pesquisa e paginação:</b> desenvolvi e otimizei recursos de busca, filtros e paginação para melhorar a navegação em grandes volumes de dados, especialmente em consultas de pedidos, certidões e documentos.</li>
	  <li><b>Arquitetura MVC e regras de negócio:</b> trabalhei na organização da aplicação em camadas, aplicando o padrão MVC para separar responsabilidades, facilitar manutenção e melhorar a escalabilidade do sistema.</li>
	  <li><b>Banco de dados e performance:</b> implementei ajustes em consultas, procedures e manipulação de dados no SQL Server, buscando maior eficiência em operações críticas da plataforma.</li>
    </ul>

    <h3>Tecnologias Utilizadas:</h3>
    <ul>
      <li><b>ASP.NET MVC, C#, SQL Server, JavaScript, HTML5, CSS3, Certificado Digital.</b></li>
    </ul>
  `,
  imageUrl: OficioWebSite,
  websiteImgDetails: OficioWebSite,
  link: "https://oficioeletronico.com.br/",
},
{
  title: "Cenprot",
  description: `
    <p class="project-highlight">
      Projeto institucional de grande porte voltado à digitalização dos serviços de protesto no Estado de São Paulo, com atuação em módulos críticos, consultas, certidões, cancelamentos e modernização da interface.
    </p>

    <p>
      A <strong>Central de Protesto do Estado de São Paulo (CENPROT-SP)</strong> é o canal oficial dos cartórios de protesto paulistas, oferecendo serviços digitais para consulta de protestos, pedidos de certidão, cancelamento de protesto, envio de títulos e quitação de débitos protestados.
    </p>

    <p>
      Atuei na manutenção e evolução de módulos essenciais da plataforma, contribuindo para a melhoria da experiência do usuário, desempenho das consultas e organização dos fluxos digitais ligados aos serviços de protesto.
    </p>

    <h3>Serviços da plataforma</h3>
    <ul>
      <li><strong>Consulta gratuita de protesto:</strong> verificação online da situação de títulos protestados.</li>
      <li><strong>Certidão de protesto:</strong> emissão de certidões negativas e positivas.</li>
      <li><strong>Cancelamento de protesto:</strong> solicitação e acompanhamento de cancelamentos com autorização do credor.</li>
      <li><strong>Envio de títulos:</strong> envio eletrônico de títulos para protesto.</li>
      <li><strong>Quitação de débitos protestados:</strong> renegociação e quitação digital de débitos.</li>
    </ul>

    <h3>Minhas contribuições</h3>
    <ul>
      <li><strong>Manutenção de módulos em ASP.NET MVC:</strong> atuei em funcionalidades críticas da plataforma, incluindo pedidos de certidão, cancelamento de protesto e consulta de títulos.</li>

      <li><strong>Filtros de busca e paginação:</strong> desenvolvi e otimizei componentes de pesquisa e paginação para melhorar a navegação em grandes volumes de dados.</li>

      <li><strong>Reformulação do frontend:</strong> participei da modernização da interface com SASS, HTML5 e CSS3, aprimorando usabilidade, responsividade e clareza visual.</li>

      <li><strong>Banco de dados e performance:</strong> realizei ajustes em consultas, regras de negócio e manipulação de dados no SQL Server, contribuindo para maior estabilidade e eficiência da plataforma.</li>
    </ul>

    <h3>Tecnologias utilizadas</h3>
    <p>
      <strong>ASP.NET MVC, C#, SQL Server, SASS, HTML5, CSS3, JavaScript.</strong>
    </p>
  `,
  imageUrl: CenprotWebSite,
  websiteImgDetails: CenprotWebSite,
  link: "https://protestosp.com.br/",
},
    /*{
      title: "Arisp",
      description: "Website institucional desenvolvido em .NET. Atuei na implementação do layout em HTML5, Sass + CSS3 e Javascript",
      imageUrl: ArispWebsite,
      websiteImgDetails: ArispWebsite,
      link: "https://www.arisp.com.br/",
    }*/,
{
  title: "AR Arisp",
  description: `
    <p class="project-highlight">
      Website institucional desenvolvido para apresentação dos serviços de certificação digital da AR ARISP, com foco em clareza visual, navegação objetiva e experiência responsiva.
    </p>

    <p>
      A <strong>AR ARISP</strong> é uma plataforma voltada à emissão e orientação sobre certificados digitais, oferecendo informações para pessoas físicas, empresas e usuários que precisam realizar validações, agendamentos e solicitações relacionadas à certificação digital.
    </p>

    <h3>Minhas contribuições</h3>
    <ul>
      <li>
        <strong>Implementação do layout institucional:</strong> atuei na construção das páginas seguindo o design proposto, garantindo fidelidade visual, organização dos blocos e boa experiência de navegação.
      </li>

      <li>
        <strong>Desenvolvimento frontend:</strong> implementei a interface utilizando HTML5, SASS, CSS3 e JavaScript, com foco em responsividade, hierarquia visual e compatibilidade entre navegadores.
      </li>

      <li>
        <strong>Estruturação de conteúdo:</strong> organizei áreas institucionais, menus, banners, chamadas de ação e seções informativas relacionadas aos serviços de certificados digitais.
      </li>

      <li>
        <strong>Integração com ambiente .NET:</strong> trabalhei na adaptação do frontend dentro da estrutura da aplicação, mantendo a consistência visual e funcional do projeto.
      </li>
    </ul>

    <h3>Tecnologias utilizadas</h3>
    <p>
      <strong>.NET, HTML5, SASS, CSS3, JavaScript.</strong>
    </p>
  `,
  imageUrl: ArArispWebSite,
  websiteImgDetails: ArArispWebSite,
  link: "https://ar.arisp.com.br/",
},

  ]

  const handleOpen = (titleProject, detailsProject, websiteImgDetails, linkProject) => {
    setOpen(true);
    settitleProject(titleProject);
    setdetailsProject(detailsProject);
    setwebsiteImgDetails(websiteImgDetails);
    setlinkProject(linkProject);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const classes = useStyles();

  if (loading) {
    return <LinearProgress color="secondary" />;
  } else {
    return (

      <>
<nav className="portfolio-category-menu">
  <a className={categoria === "net" ? "active" : ""} href="/#/portfolio/net">
    .NET
  </a>

  <a className={categoria === "react" ? "active" : ""} href="/#/portfolio/react">
    React JS
  </a>

  <a className={categoria === "wordpress" ? "active" : ""} href="/#/portfolio/wordpress">
    WordPress/PHP
  </a>

</nav>
	  <section id="net" className="portfolio-section">
<header className="portfolio-section-header">
    <span className="portfolio-section-label">Portfólio técnico</span>

    <Typography
      gutterBottom
      variant="h4"
      component="h2"
      className={classes.titlePortifolio}
    >
      Projetos desenvolvidos em .NET
    </Typography>

    <p className="portfolio-section-description">
      Sistemas corporativos desenvolvidos com ASP.NET, C#, SQL Server,
      autenticação segura, certificado digital e regras críticas de negócio.
    </p>
  </header>
        <div className="display-projects">
          {portifoliosNET.map((row) => (
             <article className="project-card" key={row.title}>
				<h3><a href={row.link} target="_blank" rel="noopener noreferrer">{row.title} <span className="external-icon">↗</span></a></h3>
              <div className="project-image">
                <img src={row.imageUrl} alt={row.title} />
              </div>
              <div className="project-info">
                 <div dangerouslySetInnerHTML={{ __html: row.description }} />
              </div>
            </article>
          ))}
        </div>
</section>
<section id="react" className="portfolio-section">
        <header className="portfolio-section-header">
    <span className="portfolio-section-label">Portfólio técnico</span>

    <Typography
      gutterBottom
      variant="h4"
      component="h2"
      className={classes.titlePortifolio}
    >
      Projetos desenvolvidos em React JS
    </Typography>

    <p className="portfolio-section-description">
      Aplicações web desenvolvidas com React, JavaScript, consumo de APIs,
      componentização e interfaces responsivas.
    </p>
  </header>
		        <div className="display-projects">
          {portfoliosReact.map((row) => (
            <div className="project-card" key={row.title}>
				<h3><a href={row.link} target="_blank" rel="noopener noreferrer">{row.title} <span className="external-icon">↗</span></a></h3>
              <div className="project-image">
                <img src={row.imageUrl} alt={row.title} />
              </div>
              <div className="project-info">
                <div dangerouslySetInnerHTML={{ __html: row.description }} />
              </div>
            </div>
          ))}
        </div>
		</section>
		<section id="wordpress" className="portfolio-section">
<header className="portfolio-section-header">
    <span className="portfolio-section-label">Portfólio técnico</span>

    <Typography
      gutterBottom
      variant="h4"
      component="h2"
      className={classes.titlePortifolio}
    >
      Projetos desenvolvidos em WordPress
    </Typography>

    <p className="portfolio-section-description">
      Sites institucionais e projetos personalizados desenvolvidos com WordPress,
      Elementor, temas customizados, CPT, ACF e otimização para performance.
    </p>
  </header>

		 <div className="display-projects">
          {portifoliosWP.map((row) => (
            <div className="project-card" key={row.title}>
				<h3><a href={row.link} target="_blank" rel="noopener noreferrer">{row.title} <span className="external-icon">↗</span></a></h3>
              <div className="project-image">
                <img src={row.imageUrl} alt={row.title} />
              </div>
              <div className="project-info">
                <div dangerouslySetInnerHTML={{ __html: row.description }} />
              </div>
            </div>
          ))}
        </div>
		</section>

      </>
    );
  }
};

export default Portfolio;
